// extracted by mini-css-extract-plugin
export default {"container":"AccountCategoryList_container__Hptt9"};